import { useWeb3ModalAccount } from '@web3modal/ethers/vue';
import { FlipCoin__factory } from 'public/abi/evm/types';
import useProvider from '~/composables/useProvider';
import type { ContractCallParams } from '~/types/Web3Provider';
import type { StartGameDTO } from '~/types/FlipCoin';
import { parseUnits } from 'ethers';

export default () => {
  const { address } = useWeb3ModalAccount();
  const { sendContractMethod } = useSendContractMethod();
  const { flipCoinContract } = useEnvs();
  const { getProvider } = useProvider();
  const { getSigner } = useProvider();

  type Web3Confirmation = (confirmations?: number) => void;

  const sendContractMethodExtended = async <T extends Record<any, any>, M extends keyof T>(
    sendParams: ContractCallParams<T, M>,
    onConfirmation?: (confirmations?: number) => void
  ) => {
    const from = address.value;
    return sendContractMethod({ ...sendParams, from }, onConfirmation);
  };

  const cancelGame = async (gameId: number, onConfirmation?: Web3Confirmation) => {
    return sendContractMethodExtended(
      {
        contract: FlipCoin__factory.connect(flipCoinContract, await getSigner()),
        methodName: 'cancelGame',
        args: [gameId]
      },
      onConfirmation
    );
  };

  const startGame = async (startGameDTO: StartGameDTO, onConfirmation?: Web3Confirmation) => {
    const { isOdd, token, playAmount } = startGameDTO;

    return sendContractMethodExtended(
      {
        contract: FlipCoin__factory.connect(flipCoinContract, await getSigner()),
        methodName: 'startGame',
        args: [isOdd, token, parseUnits(playAmount.toString())]
      },
      onConfirmation
    );
  };

  const joinGame = async (gameId: number, onConfirmation?: Web3Confirmation) => {
    return sendContractMethodExtended(
      {
        contract: FlipCoin__factory.connect(flipCoinContract, await getSigner()),
        methodName: 'play',
        args: [gameId]
      },
      onConfirmation
    );
  };

  const getLastAddedSPTimeAndMaxSP = (tokenAddress: string) => {
    return FlipCoin__factory.connect(flipCoinContract, getProvider()).getLastAddedSPTimeAndMaxSP(
      String(address.value),
      tokenAddress
    );
  };

  return {
    startGame,
    cancelGame,
    joinGame,
    getLastAddedSPTimeAndMaxSP
  };
};
